// Sentinel filter value meaning "match ANY value". Picking it sends an explicit
// empty override for the listened field, which Looker treats as no restriction —
// so a tile's own baked-in filter (e.g. a default event name) is cleared and the
// tile shows every value, rather than falling back to that default the way an
// unset/blank filter does. Chosen to be vanishingly unlikely to collide with a
// real dimension value.
export const ANY_VALUE = ' __ANY_VALUE__';

// Human label for the sentinel in the UI.
export const ANY_VALUE_LABEL = 'Any value';
